import React, { useContext, useEffect, useState } from 'react'

import Button from 'karrierhub-ui/dist/common/src/components/Button'
import MenuBase from 'karrierhub-ui/dist/common/src/components/Menu'

import { WappContext, withWapp } from 'wapplr-react/dist/common/Wapp'
import getUtils from 'wapplr-react/dist/common/Wapp/getUtils'

import AppContext from '../../App/context'

import style from './style.css'
import AccountContext from '../context'
import getMenu from '../menu'

function AutoSubmit(props) {

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const { wapp } = context

    const {
        style,
        autoSubmit = -1,
        onSubmit,
        size
    } = props

    const [s, setS] = useState(autoSubmit)

    useEffect(() => {
        let t
        if (autoSubmit >= 0) {
            if (s > 0) {
                t = setTimeout(() => setS(s - 1), 1000)
            } else {
                setS(-1)
                if (onSubmit) {
                    onSubmit()
                }
            }
        }
        return () => {
            if (t) {
                clearTimeout(t)
            }
        }
    })

    return (
        <div className={style.autoSubmit}>
            <Button
                variant={'contained'}
                color={'secondary'}
                onClick={(e) => {
                    e.preventDefault()
                    wapp.client.history.go(-1)
                }}
                size={size}
                fullWidth={true}
            >
                {appContext.menus.backMenu}
            </Button>
            <Button
                variant={'contained'}
                color={'secondary'}
                onClick={onSubmit}
                type={'submit'}
                size={size}
                fullWidth={true}
            >
                {appContext.labels.logoutSubmitLabel(s)}
            </Button>
        </div>
    )

}

function Profile(props) {

    const {
        logout,
        autoSubmit = logout ? 5 : 0,
        size
    } = props

    const accountContext = useContext(AccountContext)
    const { parentRoute, name, type } = accountContext

    const appContext = useContext(AppContext)
    const context = useContext(WappContext)
    const utils = getUtils(context)

    const { wapp } = context

    async function onSubmit(e) {
        if (e) {
            e.preventDefault()
        }
        await utils.logout({ requestName: name + 'Logout', redirect: { pathname: parentRoute, search: '', hash: '' } })
    }

    wapp.styles.use(style)

    return (
        <div className={style.settings}>
            {(!logout) ?
                <div className={style.menu}>
                    <MenuBase
                        MenuItemProps={{
                            size: size
                        }}
                        menu={getMenu({ appContext, type })}
                    />
                </div>
                :
                <form className={style.form}
                      autoComplete={'off'}
                      noValidate
                      onSubmit={onSubmit}
                >
                    <AutoSubmit
                        style={style}
                        autoSubmit={autoSubmit}
                        onSubmit={onSubmit}
                        size={size}
                    />
                </form>
            }
        </div>
    )
}

export default withWapp(Profile)
